<div class="loading"  [ngClass]="size">
  <img src="../../../assets/loading.svg" alt="Loading..." />
</div>
